/* eslint-disable max-len */
import types from '../types'

import {getBaseModels} from './getBaseModels'
import {getCustomModels} from './getCustomModels'
import {getOrgModelAccess} from './getOrgModelAccess'
import modelData from '../modelData.json'

export const getModelMetaData = (orgId, authKey) => async (dispatch) => {
  try {
    const activeModelIds = await dispatch(getOrgModelAccess(orgId, authKey))
    const baseModels = await dispatch(getBaseModels(orgId))
    const customModels = await dispatch(getCustomModels(activeModelIds, orgId))
    const combined = Object.assign({}, baseModels, customModels)
    if (process.env.REACT_APP_AIE_MODELS) {
      const aieEntries = process.env.REACT_APP_AIE_MODELS.split(',')
      for (const entry of aieEntries) {
        const [capability, tier] = entry.split('.')
        const key = `aie_${capability}_${tier}`
        const clone = JSON.parse(JSON.stringify(modelData.customModels['Rikai2']))
        clone['public']['metadata']['name'] = `AIE: ${capability}.${tier}`
        clone['public']['metadata']['description'] = `AIE: ${capability}.${tier}`
        clone['public']['metadata']['isAIE'] = true
        clone['public']['metadata']['capability'] = capability
        clone['public']['metadata']['tier'] = tier
        clone['public']['metadata']['priority'] = Infinity
        combined[key] = clone
      }
    }
    if (process.env.REACT_APP_HIDDEN_MODELS) {
      const hidden = process.env.REACT_APP_HIDDEN_MODELS.split(',')
      for (const id of hidden) {
        delete combined[id.trim()]
      }
    }
    const modelKeys = Object.keys(combined)
    const sorted = {}
    modelKeys.sort((aKey, bKey) => {
      const bVal = combined[bKey]['public']['metadata']['priority'] || 0
      const aVal = combined[aKey]['public']['metadata']['priority'] || 0
      return bVal - aVal
    })
    for (let i = 0; i < modelKeys.length; i++) {
      const modelKey = modelKeys[i]
      const temp = {}
      temp[modelKey] = combined[modelKey]
      Object.assign(sorted, temp)
    }
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        modelMetaData: sorted,
        isLoading: false,
      },
    })
    return sorted
  } catch (error) {
    console.log(error)
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isLoading: false,
        userMessage: 'Error pulling model metadata. Please ensure that your internet connection is stable. If you continue to observe this message, report the error to support@lazarusai.com.',
        notificationType: 1,
        notificationIcon: 'warning',
      },
    })
    return {}
  }
}
